import { Modal, Radio, Form, Row, Col, Button } from 'antd'
import React, { useState } from 'react'
import { ButtonEx } from '../../../styles/button.style'
import _, { isNull } from 'lodash'
import { useDeepEffect } from '../../../utils/hooks'

const UpdateStatus = (props) => {
  const { visible, onOk, onCancel, formData, form } = props
  const { setFieldsValue, getFieldDecorator, validateFields } = form

  useDeepEffect(() => {
    if (!_.isEmpty(formData)) {
      setFieldsValue({
        status: formData.status,
      })
    }
    return () => {
      form.resetFields()
    }
  }, [formData])

  const onSubmit = (e) => {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          status: values.status
        }
        if (!_.isEmpty(formData)) {
          data.id = formData.id
        }
        onOk(data)
      }
    })
  }

  const radioStyle = {
    display: 'block',
    height: '30px',
    lineHeight: '30px',
  };

  return (
    <Modal
      width={600}
      title="Update Status"
      visible={visible}
      onCancel={onCancel}
      footer={null}
    >
      <Form onSubmit={onSubmit}>
        <Form.Item>
          {getFieldDecorator(`status`, {
            rules: [
              {
                required: true,
                message: 'กรุณาเลือก'
              }
            ]
          })(
            <Radio.Group
              name="advance"
            >
              <Radio style={radioStyle} value='ON_RESERVE'><b>ON_RESERVE - จองส่งสินค้า</b></Radio>
              <Radio style={radioStyle} value='RESERVE_ACTIVE'><b>RESERVE_ACTIVE - รอจัดส่ง (การจองครบจำนวน)</b></Radio>
              <Radio style={radioStyle} value='CONFIRM_SENT'><b>CONFIRM_SENT - รอจัดส่ง (ได้รับยืนยันส่งจากผู้ซื้อ)</b></Radio>
              <Radio style={radioStyle} value='ON_DELIVERY'><b>ON_DELIVERY - จัดส่งสินค้า</b></Radio>
              <Radio style={radioStyle} value='ARRIVE_CHECK'><b>ARRIVE_CHECK - ยืนยันน้ำหนักรับ</b></Radio>
              <Radio style={radioStyle} value='ARRIVE_PASS'><b>ARRIVE_PASS - ส่งเอกสารการเงิน</b></Radio>
              <Radio style={radioStyle} value='INVOICE_SEND'><b>INVOICE_SEND - รอรับโอนเงิน</b></Radio>
              <Radio style={radioStyle} value='CASH_DELIVER'><b>CASH_DELIVER - ยืนยันรับเงิน</b></Radio>
              <Radio style={radioStyle} value='DONE'><b>DONE - เสร็จสิ้น</b></Radio>
              <Radio style={radioStyle} value='CONFIRM_PENDING'><b>CONFIRM_PENDING - รอยืนยันส่งจากผู้ซื้อ</b></Radio>
              <Radio style={radioStyle} value='CONFIRM_CANCEL'><b>CONFIRM_CANCEL - ยกเลิก (การยืนยันส่ง)</b></Radio>
              <Radio style={radioStyle} value='CANCEL_RESERVE'><b>CANCEL_RESERVE - ยกเลิกการจอง</b></Radio>
              <Radio style={radioStyle} value='TIMEOUT'><b>TIMEOUT - หมดเวลา</b></Radio>
            </Radio.Group>)}
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>Cancel</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              OK
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedUpdateStatus = Form.create({
  name: 'UpdateStatus'
})(UpdateStatus)
export default (WrappedUpdateStatus)
